import { Text } from '@medly-components/core';
import { SvgIcon } from '@medly-components/icons';
import { centerAligned } from '@medly-components/utils';
import styled from 'styled-components';

export const BackButtonStyled = styled.button`
    text-decoration: none;
    outline: none;
    border: none;
    cursor: pointer;
    padding: 0;
    background-color: transparent;
    min-width: fit-content;
    ${centerAligned('inline-flex')}

    ${Text.Style} {
        display: none;
        color: ${({ theme }) => theme.colors.darkBlue};
    }

    ${SvgIcon} {
        margin-right: 0.8rem;
        * {
            fill: ${({ theme }) => theme.colors.darkBlue};
        }
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.M.min}px) {
        ${Text.Style} {
            display: inline-block;
        }
    }
`;
